import { get } from "../axiosUitils";

const basePath = "/city_collab/dashboard";

interface RecentActivity {
  user_name?: string;
  activity_type?: string;
  activity_title?: string;
  created_by?: string;
}

interface DashboardResponse {
  organizations: string;
  members: string;
  active_events: string;
  donations: string;
  sponsors: string;
  volunteers: string;
  donation_graph: {
    [key: string]: number;
  };
  member_graph: {
    [key: string]: number;
  };
  recent_activities?: RecentActivity[];
}

interface RecommendedExpert {
  id: string;
  full_name: string;
  first_name: string;
  last_name: string;
  organization: string;
  organization_id: string;
  address: string;
  profile_image: string | null;
  skills: string[];
  department: string;
}

class DashboardService {
  /**
   * Get dashboard statistics and graphs
   */
  getDashboardData = async (
    notifyMessage?: boolean
  ): Promise<DashboardResponse | null> => {
    try {
      const response = await get<DashboardResponse>(`${basePath}/`, {
        notifyMessage,
      });
      return response ?? null;
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      return null;
    }
  };

  /**
   * Get recommended experts
   */
  getRecommendedExperts = async (
    notifyMessage?: boolean
  ): Promise<RecommendedExpert[]> => {
    try {
      const response = await get<any>(`${basePath}/recommended-experts/`, {
        notifyMessage,
      });

      if (!response) {
        return [];
      }

      // Handle response with experts property (most common structure)
      if (response.experts && Array.isArray(response.experts)) {
        console.log("Found experts in response.experts:", response.experts);
        return response.experts;
      }

      // Handle response with success and data structure
      if (response.success && response.data && Array.isArray(response.data)) {
        return response.data;
      }

      // Handle array response directly
      if (Array.isArray(response)) {
        return response;
      }

      // Handle nested in results
      if (response.results && Array.isArray(response.results)) {
        return response.results;
      }

      // Handle nested in data
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      }

      console.warn(
        "Unexpected response structure for recommended experts:",
        response
      );
      console.log("Response type:", typeof response);
      console.log("Response keys:", response ? Object.keys(response) : "null");
      return [];
    } catch (error) {
      console.error("Error fetching recommended experts:", error);
      return [];
    }
  };
}

export default new DashboardService();
